module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-next-project-1440x400-act@2x.906257a2.jpg";